import React from 'react'

export default class ReservationSegmentCardLoadingSpinner extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.fadeInOutOverlay(this.props.show);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show && !this.props.show) {
      this.fadeInOutOverlay(true);
    } else if (this.props.show && !prevProps.show) {
      this.fadeInOutOverlay(false);
    }
  }

  render() {

    return (
      <div className="loadingOverlay" ref="overlay" style={{backgroundColor: 'transparent', zIndex: 5000}}>
        <div className="spinner"></div>
      </div>
    )
  }

  fadeInOutOverlay(show) {

    if (show) {
      $(this.refs.overlay).show();
    } else {
      $(this.refs.overlay).hide();
    }
  }

};
